import React, {useCallback} from 'react';
import { Card, Row, Col, Nav } from 'react-bootstrap';

function PerformanceDetails({performanceData}) {
    const formatFollowers = useCallback(count => {
        if (count >= 1000000000) {
            return (count / 1000000000).toFixed(1).replace(/\.0$/, '') + 'B'; // Format as billions
        } else if (count >= 1000000) {
            return (count / 1000000).toFixed(1).replace(/\.0$/, '') + 'M'; // Format as millions
        } else if (count >= 1000) {
            return (count / 1000).toFixed(1).replace(/\.0$/, '') + 'K'; // Format as thousands
        } else {
            return count; // Less than 1000, no suffix
        }
    }, []);
    return (
        <div className='d-flex flex-wrap w-100 gap-4 py-2 h-100'>
            <div className='content-detail-width user-content-details w-100'>
                <Row className="user-content">
                    <Col md={4} sm={6} xs={6} className="d-flex flex-wrap align-items-center">
                        <div className="me-2 content-icon">
                            <img src="Followers.png" alt="Instagram" className='mx-1' />
                        </div>
                        <div>
                            <small>Followers</small>
                            <p>{formatFollowers(performanceData.followerCounts)}</p>
                        </div>
                    </Col>
                    <Col md={4} sm={6} xs={6} className="d-flex flex-wrap  align-items-center">
                        <div className="me-2 content-icon">
                            <img src="Engagement.png" alt="Instagram" className='mx-1' />
                        </div>
                        <div>
                            <small>Engagement rate <i className="ri-information-line" aria-label="Total likes on all posts divided by number of followers."></i></small>
                            <p>{`${(performanceData.engagementRate * 100).toFixed(2)}%`}</p>
                        </div>
                    </Col>
                    <Col md={4} sm={6} xs={6} className="d-flex flex-wrap align-items-center">
                        <div className="me-2 content-icon">
                            <img src="Sponsored.png" alt="Instagram" className='mx-1' />
                        </div>
                        <div>
                            <small>Sponsored posts performance </small>
                            <p>{performanceData.sponsoredPostPerformance === 0 ? '-' : performanceData.sponsoredPostPerformance}</p>
                        </div>
                    </Col>
                    <Col md={4} sm={6} xs={6} className="d-flex flex-wrap align-items-center">
                        <div className="me-2 content-icon">
                            <img src="AverageLikes.png" alt="Instagram" className='mx-1' />
                        </div>
                        <div>
                            <small>Average likes per post</small>
                            <p>{formatFollowers(performanceData.avgLikes)}</p>
                        </div>
                    </Col>
                    <Col md={4} sm={6} xs={6} className="d-flex flex-wrap align-items-center">
                        <div className="me-2 content-icon">
                            <img src="AverageComments.png" alt="Instagram" className='mx-1' />
                        </div>
                        <div>
                            <small>Average comments per post</small>
                            <p>{formatFollowers(performanceData.avgComments)}</p>
                        </div>
                    </Col>
                    <Col md={4} sm={6} xs={6} className="d-flex flex-wrap align-items-center">
                        <div className="me-2 content-icon">
                            <img src="AverageViews.png" alt="Instagram" className='mx-1' />
                        </div>
                        <div>
                            <small>Average views per video</small>
                            <p>{performanceData.avgViews === 0 ? '-' : formatFollowers(performanceData.avgViews)}</p>
                        </div>
                    </Col>
                    <Col md={4} sm={6} xs={6} className="d-flex flex-wrap align-items-center">
                        <div className="me-2 content-icon">
                            <img src="Avgperreel.png" alt="Instagram" className='mx-1' />
                        </div>
                        <div>
                            <small>Average views per reel</small>
                            <p>{performanceData.avgReelViews === 0 ? '-' : formatFollowers(performanceData.avgReelViews)}</p>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default PerformanceDetails